"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const borderColor = 'white';
const styles = renderer_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: 'gray',
        backgroundColor: '#F0830F',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        color: 'white',
        flexGrow: 1,
    },
    description: {
        width: '45%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingTop: 5,
    },
    tva: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingTop: 5,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingTop: 5,
    },
    price: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingTop: 5,
    },
    amount: {
        width: '15%',
        paddingTop: 5,
    },
});
const InvoiceTableHeader = () => (react_1.default.createElement(renderer_1.View, { style: styles.container },
    react_1.default.createElement(renderer_1.Text, { style: styles.description }, "Produits"),
    react_1.default.createElement(renderer_1.Text, { style: styles.tva }, "T.V.A"),
    react_1.default.createElement(renderer_1.Text, { style: styles.qty }, "Qty"),
    react_1.default.createElement(renderer_1.Text, { style: styles.price }, "Prix unit."),
    react_1.default.createElement(renderer_1.Text, { style: styles.price }, "\u20AC HT"),
    react_1.default.createElement(renderer_1.Text, { style: styles.amount }, "\u20AC TTC")));
exports.default = InvoiceTableHeader;
